// Turn off native Webflow animations for reduced motion settings
// DISABLED: this block was commented out in Webflow. Kept for reference.
/*
// Cancel Webflow animations for users who prefer reduced motion
if (window.matchMedia("(prefers-reduced-motion)").matches) {
	const cancelAnimationsInterval = setInterval(function () {
		if (typeof Webflow == "undefined" || typeof Webflow.require == "undefined") {
			return;
		}

		clearInterval(cancelAnimationsInterval);

		// Get the interactions data from Webflow's state
		const interactionsData = Webflow.require('ix2').store.getState().ixData;
		// Filter out all non-click events from the interactions
		interactionsData.events = Object.fromEntries(
			Object.entries(interactionsData.events).filter(eventEntry => {
				return /^MOUSE_.*CLICK$/.test(eventEntry[1].eventTypeId);
			})
		);
		// Put the data in the format that Webflow expects it
		interactionsData.site = { mediaQueries: interactionsData.mediaQueries };

		// Stop Webflow's handling of animations
		Webflow.require("ix2").destroy();

		// Reset the inline styles for every element that has already been initialized
		const animatedElementsSelector = "[style*='will-change'], [style*='opacity: 0']";
		for (const animatedEl of document.querySelectorAll(animatedElementsSelector)) {
			animatedEl.style = "";
		}

		// Re-initialize Webflow interactions for click-related events only
		Webflow.require('ix2').init(interactionsData);
	}, 10);
}
*/

// HubSpot Form Embed Script
// NOTE: External <script src> tag, not inline JavaScript, so it cannot live in this file.
// It must stay in the Webflow custom footer code, loaded before this file:
//   <script
//     charset="utf-8"
//     type="text/javascript"
//     src="//js.hsforms.net/forms/embed/v2.js"
//     async
//     defer
//     crossorigin="anonymous"
//   ></script>

// Hubform
// NOTE: External <script src> tag, not inline JavaScript, so it cannot live in this file.
// It must stay in the Webflow custom footer code, loaded before this file:
//   <script
//     src="https://cdn.jsdelivr.net/gh/oimachistudio/hubform@latest/hubform.js?hubspot_region=na1&hubspot_portalId=22070921&key=a1va2TjlfObm"
//     crossorigin="anonymous"
//   ></script>

hubformSettings({
	animationType: 'fade',
	delay: 800
});

// Hubspot Tracking Pixel - Added by Lydia 2.25.25
runUnlessCookieIsTrue('__cl_no_marketing', function() {
  script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = "hs-script-loader";
  script.async = true;
  script.defer = true;
  script.src = 'https://js.hs-scripts.com/22070921.js';
  document.getElementsByTagName('head')[0].appendChild(script);
});

// Cookie.js
// NOTE: External <script src> tag, not inline JavaScript, so it cannot live in this file.
// It must stay in the Webflow custom footer code, loaded before this file:
//   <script
//     defer
//     src="https://cdn.jsdelivr.net/npm/js-cookie@3.0.5/dist/js.cookie.min.js"
//     crossorigin="anonymous"
//   ></script>

// Helper: Send Hubspot form data to PostHog via Rails API
function captureHubSpotFormSubmissionToPostHog({ hubSpotFormId, pathName, submissionValues }) {
  return fetch('/api/v1/post_hog/form_submissions', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      hubspot_form_submission_values: submissionValues,
      hubspot_form_id: hubSpotFormId,
      distinct_id: posthog.get_distinct_id(), // Brooks 07/14/2025 - Added for PR #32376
      path_name: pathName,
    }),
  })
  .then(() => true)
  .catch((error) => {
    console.error('Error capturing HubSpot form submission:', error);
    return false;
  })
}

// Attach MutationObserver to Hubspot form to set lead source and capture modal form submission
const getLeadSource = (pathname, search) => {
  const leadSources = {
    '': 'Web: Home Page',
    '/about': 'Web: About Page',
    '/benchmark-assessments': 'Web: Benchmark Assessments Page',
    '/contact': 'Web: Contact Page',
    '/ela-curriculum': 'Web: ELA Curriculum Page',
    '/ela-curriculum-pilot': 'Web: Pilot Page',
    '/impact': 'Web: Impact Page',
    '/pricing': 'Web: Pricing Page',
    '/professional-development': 'Web: 360 PD',
    '/rostering-and-lms-integrations': 'Web: Integrations Page',
    '/state-resources': 'Web: State Resources',
    '/georgia': 'Web: GA Page',
    '/illinois': 'Web: IL Page',
    '/new-york': 'Web: NY Page',
    '/ohio': 'Web: OH Page',
    '/new-jersey': 'Web: NJ Page',
    '/webinars': 'Web: Webinars',
    '/ela-teacher-resources': 'Web: ELA Teacher Resources Page',
    '/workbooks': 'Web: Workbooks Page',
    '/wisconsin': 'Web: WI Page',
    '/north-carolina': 'Web: NC Page',
    '/california': 'Web: CA Page',
    '/washington': 'Web: WA Page',
    '/text-library': 'Web: Text Library',
    '/skills-lessons': 'Web: Target Lessons',
  };

  const params = new URLSearchParams(search);
  const channel = params.get('channel');
  if (channel && typeof channel === 'string') {
    return channel;
  }

  const canonicalPath = pathname.replace(/\/$/, ''); // Remove trailing slash, if any
  return (
    Object.entries(leadSources).find(([path]) => canonicalPath === path)?.[1] ??
    `Web: ${pathname}`
  );
};

const pathname = window.location.pathname;
const search = window.location.search;
const leadSource = getLeadSource(pathname, search);

let observer = null;

const attachObserverToModal = () => {
  const modalWrapper = document.querySelector("[hf-modal='wrapper']");
  const modalContainer = document.querySelector("article[hf-modal='hubspot-form']");

  if (modalContainer && modalWrapper) {
    observer = new MutationObserver((mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (node.matches && node.matches("form")) {
              // Find modal to set the focus on the first element in the form
              findModal($(modalWrapper));

              // Set lead source input value
              const leadSourceInput = node.querySelector("[name='leadsource']");

              if (leadSourceInput) {
                leadSourceInput.value = decodeURIComponent(leadSource);
              } else {
                console.error("[Error][Modal]: Input element with name 'leadsource' not found in the form.");
              }

              // Attach submit event listener to form to create Posthog custom event
              node.addEventListener("submit", (event) => {
                const formData = new FormData(node);
                const submissionValues = Object.fromEntries(formData.entries());

                captureHubSpotFormSubmissionToPostHog({
                  hubSpotFormId: node.getAttribute("data-form-id") || "unknown-modal-form-id",
                  pathName: window.location.pathname,
                  submissionValues,
                });
              });
            }
          });
        }
      }
    });

    observer.observe(modalContainer, {
      childList: true,
    });
  } else {
    console.log("[Debug][Modal]: Modal not found, will retry.");
  }
};

// Polling function to detect when the modal reappears
const startPollingForModal = () => {
  const interval = setInterval(() => {
    const modalContainer = document.querySelector("article[hf-modal='hubspot-form']");
    if (modalContainer && !observer) {
      attachObserverToModal();  // Attach observer if modal exists
    }
  }, 500); // Check every 500ms

  // Stop polling after some time to avoid infinite checks
  setTimeout(() => {
    clearInterval(interval);
  }, 30000); // Stop after 30 seconds
};

document.addEventListener("DOMContentLoaded", startPollingForModal);

// Webflow / Hubspot Integration - Load Custom Thank You
document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('.form_block-wrap');
  const thankYouMessage = document.querySelector('.form_thank-you');

  if (form) {
    form.addEventListener('submit', function(e) {
    e.preventDefault();

    // Show thank you message
    thankYouMessage.style.display = 'block';

    // Hide the form (you may need to adjust the selector)
    form.style.display = 'none';

    // You can add additional animations here if desired
    // For example:
    // form.style.opacity = '0';
    // thankYouMessage.style.opacity = '1';
    });
  }
});

// LinkedIn - Added by Lydia 2.24.25
runUnlessCookieIsTrue('__cl_no_marketing', function() {
_linkedin_partner_id = "4958868"; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id); (function(l) { if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; window.lintrk.q=[]} var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})(window.lintrk);
});

// Reddit - Added by Elsie 12.5.25
runUnlessCookieIsTrue('__cl_no_marketing', function() {
!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);rdt('init','a2_i46qtbm1dfx1');rdt('track', 'PageVisit');
});

// GSAP Animation # disabling as of 3/30/2026
// DISABLED: this block was commented out in Webflow. Kept for reference.
/*
<script src="https://unpkg.com/split-type" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.3/gsap.min.js" crossorigin="anonymous"></script>
<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.11.3/ScrollTrigger.min.js" crossorigin="anonymous"></script>


window.addEventListener("DOMContentLoaded", (event) => {
  // Split text into spans
  let typeSplit = new SplitType("[text-split]", {
    types: "words, chars",
    tagName: "span"
  });

  // Link timelines to scroll position
  function createScrollTrigger(triggerElement, timeline) {
    // Reset tl when scroll out of view past bottom of screen
    ScrollTrigger.create({
      trigger: triggerElement,
      start: "top bottom",
      onLeaveBack: () => {
        timeline.progress(0);
        timeline.pause();
      }
    });
    // Play tl when scrolled into view (60% from top of screen)
    ScrollTrigger.create({
      trigger: triggerElement,
      start: "top 60%",
      onEnter: () => timeline.play()
    });
  }

  $("[words-slide-up]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".word"), { opacity: 0, yPercent: 100, duration: 0.5, ease: "back.out(2)", stagger: { amount: 0.5 } });
    createScrollTrigger($(this), tl);
  });

  $("[words-rotate-in]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.set($(this).find(".word"), { transformPerspective: 1000 });
    tl.from($(this).find(".word"), { rotationX: -90, duration: 0.6, ease: "power2.out", stagger: { amount: 0.6 } });
    createScrollTrigger($(this), tl);
  });

  $("[words-slide-from-right]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".word"), { opacity: 0, x: "1em", duration: 0.6, ease: "power2.out", stagger: { amount: 0.2 } });
    createScrollTrigger($(this), tl);
  });

  $("[letters-slide-up]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".char"), { yPercent: 100, duration: 0.2, ease: "power1.out", stagger: { amount: 0.6 } });
    createScrollTrigger($(this), tl);
  });

  $("[letters-slide-down]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".char"), { yPercent: -120, duration: 0.3, ease: "power1.out", stagger: { amount: 0.7 } });
    createScrollTrigger($(this), tl);
  });

  $("[letters-fade-in]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".char"), { opacity: 0, duration: 0.2, ease: "power1.out", stagger: { amount: 0.8 } });
    createScrollTrigger($(this), tl);
  });

  $("[letters-fade-in-random]").each(function (index) {
    let tl = gsap.timeline({ paused: true });
    tl.from($(this).find(".char"), { opacity: 0, duration: 0.05, ease: "power1.out", stagger: { amount: 0.4, from: "random" } });
    createScrollTrigger($(this), tl);
  });

  $("[scrub-each-word]").each(function (index) {
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: $(this),
        start: "top 80%",
        end: "top center",
        scrub: true
      }
    });
    tl.from($(this).find(".word"), { opacity: 0.2, duration: 0.8, ease: "expo.out", stagger: { each: 0.8 }, scrub: 2 });
  });

  // Avoid flash of unstyled content
  gsap.set("[text-split]", { opacity: 1 });
});
*/

// Lenis Smooth Scrolling
// NOTE: External <script src> tag, not inline JavaScript, so it cannot live in this file.
// It must stay in the Webflow custom footer code, loaded before this file:
//   <script src="https://unpkg.com/lenis@1.3.4/dist/lenis.min.js" crossorigin="anonymous"></script>

// LENIS SMOOTH SCROLL

let lenis;
const prefersReducedMotionQuery = matchMedia('(prefers-reduced-motion: reduce)');

if (Webflow.env("editor") === undefined && (!prefersReducedMotionQuery.matches && location.pathname !== '/webinars')) {
  lenis = new Lenis({
    // BKJ - leaving these uncommented values as reference. They caused motion sickness problems, and the new values
    // address this
    //lerp: 0.1,
    //wheelMultiplier: 0.7,
    lerp: 0.9,
    wheelMultiplier: 0.5,
    gestureOrientation: "vertical",
    normalizeWheel: false,
    smoothTouch: false
  });
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);
}
$("[data-lenis-start]").on("click", function () {
  lenis.start();
});
$("[data-lenis-stop]").on("click", function () {
  lenis.stop();
});
$("[data-lenis-toggle]").on("click", function () {
  $(this).toggleClass("stop-scroll");
  if ($(this).hasClass("stop-scroll")) {
    lenis.stop();
  } else {
    lenis.start();
  }

  //reload lenis animations
$(document).ready(function(){lenis.start();})
  /**/
});

// Fixing the overlay on the home page - Damon 03.01.25
$(document).ready(() => {
  const toggle = document.querySelector('#w-dropdown-toggle-0');
  const overlay = document.querySelector('.navbar_overlay');
  toggle.addEventListener('click', function() {
    const header = document.querySelector('.nav.w-nav');
    const headerRect = header.getBoundingClientRect();
    overlay.style.top = `${headerRect.bottom}px`;
  });
});

// Conditional logic based on user_type cookie - Cindy 03.04.25
function getCookie(name) {
  const cookies = document.cookie.split("; ");
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split("=");
    if (cookieName === name) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
}

document.addEventListener("DOMContentLoaded", function () {
  const userTypeCookie = getCookie("user_type");

  if (userTypeCookie) {
    const navbarContainer = document.querySelector(".navbar_container-wrap");


    if (navbarContainer) {
      // conditionally set the href of the logo link based on the user type
      const logoLink = navbarContainer.querySelector(".navbar_logo-link");

      if (logoLink) {
        if (userTypeCookie === "teacher") {
          logoLink.href = "/en/home";
        } else if (userTypeCookie === "student") {
          logoLink.href = "/en/students/student_lessons"
        }
      }

      // modify login link to take logged in users to logged in home page
      // hide signup and contact sales links for logged in users
      const logInLink = document.querySelector(".nav-link-login");
      const signUpLink = document.querySelector(".nav-link-signup");
      const contactSalesLink = document.querySelector(".nav-link-request-quote");

      if (logInLink) {
        logInLink.innerText = "Home";

        if (userTypeCookie === "teacher") {
          logInLink.href = "/en/home";
        } else if (userTypeCookie === "student") {
          logInLink.href = "/en/students/student_lessons";
        }
      }

      if (signUpLink) {
        signUpLink.style.display = "none";
      }

      if (contactSalesLink) {
        contactSalesLink.style.display = "none";
      }
    }
  }
});

// Clear cookie preferences when the "Manage cookies" link is clicked
// (Originally in a <script defer> tag in Webflow; defer has no effect on inline scripts, so ordering is unchanged.)
async function clearCookiePreferences() {
  await window.cookieStore.delete('__cl_no_analytics');
  await window.cookieStore.delete('__cl_no_marketing');
  window.location.reload();
}

document.querySelector("#manage-cookies").addEventListener("click", clearCookiePreferences);

// Accessible Modals
function findModal(elem) {
  var tabbable = elem.find('select, input, textarea, button, a').filter(':visible');

  var firstTabbable = tabbable.first();
  var lastTabbable = tabbable.last();

  /*remove existing handlers to prevent stacking*/
  firstTabbable.off('keydown.modal');
  lastTabbable.off('keydown.modal');
  elem.off('keydown.modal');

  /*set focus on first input*/
  firstTabbable.focus();

  /*redirect last tab to first input*/
  lastTabbable.on('keydown.modal', function(e) {
    if ((e.which === 9 && !e.shiftKey)) {
      e.preventDefault();
      firstTabbable.focus();
    }
  });

  /*redirect first shift+tab to last input*/
  firstTabbable.on('keydown.modal', function(e) {
    if ((e.which === 9 && e.shiftKey)) {
      e.preventDefault();
      lastTabbable.focus();
    }
  });

  /* allow escape key to close modal */
  elem.on('keydown.modal', function(e) {
    if (e.keyCode === 27) {
      $(elem).find('[hf-modal="close"], .signup_modal-close-button').click();
    };
  });
};

$(document).ready(function() {
  var buttonThatOpenedModal;

  // Hubspot modals
  const hubformOpenButton = $('[hf-form-id]').filter(function () {
    return $(this).attr('hf-form-id').trim() !== '';
  });
  const hubformModal = $('[hf-modal="component"]');
  const hubformCloseButtons = $('[hf-modal="close"], [hf-modal="overlay"]');

  hubformOpenButton.on('click', function() {
    hubformModal.css('display', 'flex');
    findModal(hubformModal);
    buttonThatOpenedModal = $(this);
  });

  hubformCloseButtons.on('keydown', function(e) {
    // Only activate on spacebar and enter
    if (e.which === 13 || e.which === 32) {
      e.preventDefault();
      var evt = document.createEvent("MouseEvents");
      evt.initMouseEvent("click", true, true, window);
      $(this).get(0).dispatchEvent(evt);
    }
  });

  hubformCloseButtons.on('click', function() {
    hubformModal.css('display', 'none');
    if (buttonThatOpenedModal) {
      buttonThatOpenedModal.focus();
      buttonThatOpenedModal = null;
    }
  });

  // Sign up modal
  const signUpOpenButton = $('.nav-link-signup');
  const signUpModal = $('.signup_modal-component');
  const signUpCloseButtons = $('.signup_modal-close-button, .signup_modal-overlay');

  // Save trigger for focus return
  signUpOpenButton.on('click', function() {
    buttonThatOpenedModal = $(this);
  });

  // Observe when Webflow displays the modal
  const signupObserver = new MutationObserver(() => {
    if (signUpModal.css('display') === 'flex') {
      findModal(signUpModal);
    }
  });

  if (signUpModal.length) {
    signupObserver.observe(signUpModal.get(0), {
      attributes: true,
      attributeFilter: ['style']
    });
  }

  signUpCloseButtons.on('keydown', function(e) {
    if (e.which === 13 || e.which === 32) {
      e.preventDefault();
      var evt = document.createEvent("MouseEvents");
      evt.initMouseEvent("click", true, true, window);
      $(this).get(0).dispatchEvent(evt);
    }
  });

  signUpCloseButtons.on('click', function() {
    if (buttonThatOpenedModal) {
      buttonThatOpenedModal.focus();
      buttonThatOpenedModal = null;
    }
  });
});

// Adapted from https://status.commonlit.org/en/39d92932/widget/script.js
// Changes from upstream are commented below
(function () {
  /**
   * Configurations
   * you can change widget configuration from here
   */
  const CONFIG = {
    url: 'https://status.commonlit.org',
    frameUrl: 'https://status.commonlit.org/widget',
    position: 'bottom-right',
    incident: {
      textColor: '#333333',
      backgroundColor: '#FFFFFF',
    },
    maintenance: {
      textColor: '#333333',
      backgroundColor: '#FFFFFF',
    },
    text: {
      viewLatestUpdates: 'View latest updates',
      lastUpdated: 'Last updated {{time}} ago',
      scheduledFor: 'Scheduled for',
      year: 'year',
      years: 'years',
      month: 'month',
      months: 'months',
      day: 'day',
      days: 'days',
      hour: 'hour',
      hours: 'hours',
      minute: 'minute',
      minutes: 'minutes',
    },
  };

  const isMobile = screen.width < 600;

  /**
   * Initialization
   */
  async function init() {
    while (true) {
      try {
        await fetchIssues();
      } catch {}
      await wait(3 * 60 * 1000); // every 3 minutes
    }
  }

  async function fetchIssues() {
    let result = await fetch(
      'https://api.instatus.com' +
        '/issues?locale=en&host=status.commonlit.org',
    ).then((res) => {
      if (res.ok) {
        return res.json();
      } else {
        return Promise.reject(res.statusText);
      }
    });

    let issues = [];

    result.activeIncidents?.forEach((incident) => {
      issues.push({
        type: 'incident',
        id: incident.id,
        status: incident.status,
        title: incident.name,
        updatedAt: incident.updatedAt,
        theme: CONFIG.maintenance,
        text: CONFIG.text,
      });
    });

    result.activeMaintenances?.forEach((maintenance) => {
      // Change from Instatus' setup: don't flag upcoming maintenance in a popup
      if (maintenance.status != 'NOTSTARTEDYET') {
        issues.push({
          type: 'maintenance',
          id: maintenance.id,
          status: maintenance.status,
          title: maintenance.name,
          updatedAt: maintenance.updatedAt,
          date: maintenance.date,
          theme: CONFIG.incident,
          text: CONFIG.text,
        });
      }
    });

    notifyIssues(issues);
  }

  /**
   * Frame
   */

  let frames = [];
  let dismissedFrameIds = {};
  let closedFrames = [];
  let retreviedLocalClosedFrames = localStorage.getItem('closedFrames');
  let localClosedFrames = JSON.parse(retreviedLocalClosedFrames);

  function notifyIssues(issues) {
    frames.forEach((frame) => {
      let issue = issues.find((issue) => issue.id === frame.id);
      if (issue) {
        updateIssue(issue);
      } else {
        dismissIssue(frame.id);
      }
    });
    issues
      .filter((issue) => {
        let isDismissed = issue.id in dismissedFrameIds;
        let isOnScreen = frames.some((frame) => frame.id === issue.id);
        return !(isDismissed || isOnScreen);
      })
      .forEach((issue, i) => {
        notifyIssue({ issue, timeout: i * 200 });
      });
  }

  function notifyIssue({ issue, timeout }) {
    if (
      localStorage.hasOwnProperty('closedFrames') &&
      localClosedFrames.includes(issue.id)
    ) {
      return;
    }

    let frame = document.createElement('iframe');
    frame.id = issue.id;
    frame.src =
      CONFIG.frameUrl +
      '?incident_url=' +
      encodeURIComponent(CONFIG.url + '/' + issue.id) +
      '&issue=' +
      encodeURIComponent(JSON.stringify(issue)) +
      '&type=' +
      issue.type;
    frame.style.position = 'fixed';
    frame.style.border = 'none';
    frame.style.boxShadow =
      '0 0 #0000, 0 0 #0000, 0 25px 50px -12px rgba(0, 0, 0, 0.25)';
    frame.style.zIndex = '9999';
    frame.style.transition = 'left .3s ease, bottom .3s ease, right .3s ease';

    let frameLength = frames.length;

    if (isMobile) {
      frame.style.height = '180px';
      frame.style.width = '100vw';
      frame.style.transition = 'bottom .3s ease';
      frame.style.borderRadius = 'none';
      frame.style.left = 0;
      frame.style.bottom = '-1000px';
    } else {
      frame.style.height = '180px';
      frame.style.width = '365px';
      frame.style.borderRadius = '1rem';
      let x = '-1000px';
      let y = 50 + frameLength * 210 + 'px';
      if (CONFIG.position === 'bottom-left') {
        frame.style.left = x;
        frame.style.bottom = y;
      } else if (CONFIG.position === 'bottom-right') {
        frame.style.right = x;
        frame.style.bottom = y;
      } else if (CONFIG.position === 'bottom-center') {
        frame.style.bottom = y;
        frame.style.left = 0;
        frame.style.right = 0;
        frame.style.margin = 'auto';
      } else if (CONFIG.position === 'top-left') {
        frame.style.left = x;
        frame.style.top = y;
      } else if (CONFIG.position === 'top-right') {
        frame.style.right = x;
        frame.style.top = y;
      } else if (CONFIG.position === 'top-center') {
        frame.style.top = y;
        frame.style.left = 0;
        frame.style.right = 0;
        frame.style.margin = 'auto';
      }
    }

    frame.onload = function (e) {
      let actions = {
        showFrame: function () {
          if (isMobile) {
            frame.style.bottom = frameLength * 180 + 'px';
          } else {
            let x = '50px';
            if (
              CONFIG.position === 'bottom-left' ||
              CONFIG.position === 'top-left'
            ) {
              frame.style.left = x;
            } else if (
              CONFIG.position === 'bottom-right' ||
              CONFIG.position === 'top-right'
            ) {
              frame.style.right = x;
            }
          }
        },
        dismissFrame: function () {
          dismissIssue(issue.id);
        },
      };

      window.addEventListener(
        'message',
        function (event) {
          if (
            event.data.id === issue.id &&
            event.data.action &&
            actions.hasOwnProperty(event.data.action)
          ) {
            actions[event.data.action](event.data);
          }
        },
        false,
      );

      // animation
      setTimeout(() => {
        actions.showFrame();
      }, timeout);
    };

    document.body.appendChild(frame);

    frames.push(frame);
  }

  function updateIssue(issue) {
    let frame = frames.find((frame) => frame.id === issue.id);
    let newSrc =
      CONFIG.frameUrl +
      '?url=' +
      encodeURIComponent(CONFIG.url + '/' + issue.id) +
      '&issue=' +
      encodeURIComponent(JSON.stringify(issue));
    if (newSrc !== frame.src) {
      frame.src = newSrc;
    }
  }

  function dismissIssue(id) {
    let frame = frames.find((frame) => frame.id === id);
    dismissedFrameIds[id] = true;

    closedFrames.push(id);
    if (isMobile) {
      frame.style.bottom = '-1000px';
    } else {
      frame.style.left = '-1000px';
    }
    localStorage.setItem('closedFrames', JSON.stringify(closedFrames));
    setTimeout(() => {
      removeFrame(id);
    }, 200);
  }

  function removeFrame(id) {
    frames = frames.filter((frame) => {
      if (frame.id === id) {
        frame.remove();
        return false;
      }
      return true;
    });
    // reorder
    frames.forEach((frame, i) => {
      if (isMobile) {
        frame.style.bottom = i * 130 + 'px';
      } else {
        frame.style.bottom = 60 + i * 20 + i * 155 + 'px';
      }
    });
  }

  init();

  /**
   * utils
   */
  function wait(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }
})();
